module.exports = __webpack_public_path__ + "img/cotizacion_2.879ef0a1.svg";